import { render, staticRenderFns } from "./WebLogo.vue?vue&type=template&id=47143beb"
import script from "./WebLogo.vue?vue&type=script&lang=js"
export * from "./WebLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports